import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import SearchIcon from '@material-ui/icons/Search';

import { toast } from 'react-toastify';
import { initializePageAction } from '../../../store/theme.actions';

import TabelaPesquisaProcessos from '../../../components/Processos/Pesquisa/Tabela/TabelaPesquisaProcessos';

import withTokenInterceptor from '../../../hoc/withTokenInterceptor/withTokenInterceptor';

import {
  ComplementarySearchButton,
  Container,
  SimpleSearchContainer,
  Table,
  TableTitle,
} from './PesquisarProcessosPage.styles';
import SelectorField from '../../../components/UI/Field/Selector/SelectorField';
import {
  findEstadosAction,
  findFasesAction,
  findNegociadoresAction,
  findTiposAgendamentosAction,
  findUsuariosNegociadoresAction,
} from '../../../store/Global/LoadSelectors/loadSelectors.saga';

import {
  getCurrentIdUsuario,
  getNewPage,
  isLoading,
} from '../../../helpers/utils/utils';
import LoadingUI from '../../../components/UI/Loading/LoadingUI';
import { pesquisaProcessoController as controller } from '../../../controller/pesquisarProcessos.controller';
import { PesquisaComplementarProcesso } from '../../../components/Processos/Pesquisa/PesquisaComplementarProcesso';
import { AcoesPesquisaProcesso } from '../../../components/Processos/Pesquisa/AcoesPesquisaProcesso/AcoesPesquisaProcesso';
import { SearchButton } from '../../../components/SearchButton/SeachButton';
import CheckboxField from '../../../components/UI/Field/Checkbox/CheckboxField';
import NumberInput from '../../../components/UI/Field/Number/NumberInput';
import { getUsuarioCompletoPeloId } from '../../../services/core/usuario/usuario.services';

function hasContentInSearch(response) {
  return !response.error && response?.content.length === 0;
}

function PesquisarProcessosPage() {
  const dispatch = useDispatch();
  const history = useHistory();

  const advancedSearchRef = useRef();
  const simpleSearchFormRef = useRef();

  const [selectedIds, setSelectedIds] = useState({});
  const [selectAll, setSelectAll] = useState(false);
  const [dropdownValues, setDropdownValues] = useState(
    controller.makeDefaultDropdownSimpleSearch()
  );
  const [ordenacao, setOrdenacao] = useState(controller.makeOrdenacao());
  const [dadosPesquisa, setDadosPesquisa] = useState(
    controller.makeDefaultDadosPesquisa()
  );
  const [conteudoTabela, setConteudoTabela] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isIgnorarBaixa, setIsIgnorarBaixa] = useState(true);
  const [numeroProcesso, setNumeroProcesso] = useState(null);
  const [tipoUsuarioLogado, setTipoUsuarioLogado] = useState(null);

  const loadingDropdowns = useSelector(controller.getLoadingDropdown);
  const simpleSeachDropdown = useSelector(
    controller.getSimpleSearchDropdownItems
  );

  const idUsuarioLogado = getCurrentIdUsuario();

  const idUsuarioLogadoNaLista = useMemo(
    () =>
      Array.isArray(simpleSeachDropdown?.negociadores) &&
      simpleSeachDropdown.negociadores.some(
        ({ idUsuario }) => idUsuario === idUsuarioLogado
      ),
    [simpleSeachDropdown?.negociadores, idUsuarioLogado]
  );

  const isTipoUsuarioComercial = tipoUsuarioLogado?.idTipoUsuario === 1;

  const changeSelectAll = useCallback(
    (e) => {
      const { checked } = e.target;
      setSelectAll(checked);
      setSelectedIds(
        Object.keys(selectedIds).reduce(
          (acc, key) => ({ ...acc, [key]: checked }),
          {}
        )
      );
    },
    [selectedIds]
  );

  const changeSelectId = useCallback(
    (e) => {
      const { name, checked } = e.target;
      setSelectedIds({ ...selectedIds, [name]: checked });
    },
    [selectedIds]
  );

  const changeDropdown = useCallback((e) => {
    const { name, value } = e.target;
    setDropdownValues((old) =>
      controller.updateDropdownValue(old, name, value)
    );
  }, []);

  function resetSimpleSearch() {
    setDropdownValues(controller.makeDefaultDropdownSimpleSearch());
  }

  async function loadingWrapper(request) {
    setLoading(true);
    const response = await request();
    setDadosPesquisa(response);
    setLoading(false);
    return response;
  }

  async function openAdvancedSearch() {
    dispatch(findEstadosAction());
    dispatch(findFasesAction());
    dispatch(findNegociadoresAction());
    dispatch(findTiposAgendamentosAction());
    dispatch(findUsuariosNegociadoresAction());
    advancedSearchRef.current.openAdvancedSearch();
  }

  const pesquisarProcessosCardMural = useCallback((acao) => {
    const result = loadingWrapper(async () => {
      simpleSearchFormRef.current.reset();
      if (acao === 'processosProximoVencimento') {
        const response = await controller.pesquisarProcessosProximoVencimento();
        setSelectedIds(await controller.buscarIdsProcessosProximoVencimento());
        return response;
      }
      if (acao === 'processosComPrazoVencido') {
        const response = await controller.pesquisarProcessosComPrazoVencido();
        setSelectedIds(await controller.buscarIdsProcessosComPrazoVencido());
        return response;
      }
      if (acao === 'processosAVencer') {
        const response = await controller.pesquisarProcessosAVencer();
        setSelectedIds(await controller.buscarIdsProcessosAVencer());
        return response;
      }
      if (acao === 'processosNovos') {
        const response = await controller.pesquisarProcessosNovos();
        setSelectedIds(await controller.buscarIdsProcessosNovos());
        return response;
      }
      if (acao === 'processosAguardandoRequisicao') {
        const response =
          await controller.pesquisarProcessosAguardandoRequisicao();
        setSelectedIds(
          await controller.buscarIdsProcessosAguardandoRequisicao()
        );
        return response;
      }
      if (acao === 'meusProcessos') {
        const response = await controller.pesquisarMeusProcessos();
        setSelectedIds(await controller.buscarIdsMeusProcessos());
        return response;
      }
      return [];
    });

    setOrdenacao(controller.makeOrdenacao(true));
    return result;
  }, []);

  const pesquisarProcessosComNotificacoes = useCallback(() => {
    const result = loadingWrapper(async () => {
      simpleSearchFormRef.current.reset();
      const response = await controller.pesquisarProcessosComNotificacoes();
      setSelectedIds(await controller.buscarIdsProcessosComNotificacoes());
      return response;
    });

    setOrdenacao(controller.makeOrdenacao(true));
    return result;
  }, []);

  const pesquisarProcessosComAutorizacoes = useCallback(() => {
    const result = loadingWrapper(async () => {
      simpleSearchFormRef.current.reset();
      const response = await controller.pesquisarProcessosComAutorizacoes();
      setSelectedIds(await controller.buscarIdsProcessosComAutorizacoes());
      return response;
    });

    setOrdenacao(controller.makeOrdenacao(true));
    return result;
  }, []);

  async function changePageHandler(event, newPage) {
    loadingWrapper(async () => {
      let response;
      controller.page = newPage;
      const notificacao = new URLSearchParams(history.location.search).get(
        'notificacao'
      );
      if (notificacao) {
        response = await pesquisarProcessosComNotificacoes();
        return response;
      }
      const autorizacao = new URLSearchParams(history.location.search).get(
        'autorizacao'
      );
      if (autorizacao) {
        response = await pesquisarProcessosComAutorizacoes();
        return response;
      }

      const acao = new URLSearchParams(history.location.search).get('acao');
      if (acao) {
        response = await pesquisarProcessosCardMural(acao);
        return response;
      }

      response = await controller.pesquisar();
      return response;
    });
  }

  async function changeRowPerPageHandler(event) {
    loadingWrapper(async () => {
      controller.page = getNewPage(
        dadosPesquisa.pageable.size,
        dadosPesquisa.pageable.page,
        event.target.value
      );
      controller.size = event.target.value;
      let response;

      const notificacao = new URLSearchParams(history.location.search).get(
        'notificacao'
      );
      if (notificacao) {
        response = await pesquisarProcessosComNotificacoes();
        return response;
      }
      const autorizacao = new URLSearchParams(history.location.search).get(
        'autorizacao'
      );
      if (autorizacao) {
        response = await pesquisarProcessosComAutorizacoes();
        return response;
      }

      const acao = new URLSearchParams(history.location.search).get('acao');
      if (acao) {
        response = await pesquisarProcessosCardMural(acao);
        return response;
      }

      response = await controller.pesquisar();
      return response;
    });
  }

  async function pesquisaComFiltroSimples(e) {
    e.preventDefault();
    const result = await loadingWrapper(async () => {
      history.location.search = '';
      const formData = new FormData(e.target);

      // Se houver numeroProcesso preenchido, remove o idUsuarioNegociador
      if (formData.get('numeroProcesso')) {
        formData.delete('idUsuarioNegociador');
      }

      // Se for usuário comercial
      if (isTipoUsuarioComercial) {
        formData.set('idUsuarioComercial', idUsuarioLogado);
      }

      const response = await controller.pesquisarComFiltroSimples(
        formData,
        dadosPesquisa.pageable.size
      );
      setSelectedIds(await controller.buscarIdsProcessos());
      return response;
    });

    setOrdenacao(controller.makeOrdenacao(true));
    if (hasContentInSearch(result)) {
      toast.warning(
        'Nenhum resultado foi encontrado relacionado à sua pesquisa'
      );
    }
  }

  async function pesquisarComFiltroEspecial(e) {
    e.preventDefault();
    const result = await loadingWrapper(async () => {
      history.location.search = '';
      simpleSearchFormRef.current.reset();
      const response = await controller.pesquisarComFiltroEspecial(
        isTipoUsuarioComercial,
        new FormData(e.target),
        dadosPesquisa.pageable.size
      );
      setSelectedIds(await controller.buscarIdsProcessos());
      if (!response.error) {
        advancedSearchRef.current.closeAdvancedSearch();
      }
      return response;
    });

    setOrdenacao(controller.makeOrdenacao(true));
    if (hasContentInSearch(result)) {
      toast.warning(
        'Nenhum resultado foi encontrado relacionado à sua pesquisa'
      );
    }
    return result;
  }

  async function pesquisarComFiltroAvancado(e) {
    e.preventDefault();
    const result = await loadingWrapper(async () => {
      history.location.search = '';
      simpleSearchFormRef.current.reset();
      const formData = new FormData(e.target);

      // Se houver numeroProcesso preenchido, remove o idUsuarioNegociador
      if (formData.get('numeroProcesso')) {
        formData.delete('idUsuarioNegociador');
      }

      const response = await controller.pesquisarComFiltroAvancada(
        isTipoUsuarioComercial,
        formData,
        dadosPesquisa.pageable.size
      );
      if (!response.error) {
        advancedSearchRef.current.closeAdvancedSearch();
      }
      setSelectedIds(await controller.buscarIdsAvancadoProcessos());
      return response;
    });

    setOrdenacao(controller.makeOrdenacao(true));
    if (hasContentInSearch(result)) {
      toast.warning(
        'Nenhum resultado foi encontrado relacionado à sua pesquisa'
      );
    }
  }

  const applyOrder = useCallback(
    async (columnName) => {
      const notificacao = new URLSearchParams(history.location.search).get(
        'notificacao'
      );
      const autorizacao = new URLSearchParams(history.location.search).get(
        'autorizacao'
      );
      const acao = new URLSearchParams(history.location.search).get('acao');

      if (
        controller.hasNotFilledPayload() &&
        !notificacao &&
        !autorizacao &&
        !acao
      ) {
        return;
      }
      const result = await loadingWrapper(async () => {
        const response = await controller.pesquisarAplicandoOrdenacao(
          columnName,
          ordenacao.arrow,
          notificacao,
          autorizacao,
          acao
        );
        return response;
      });
      setOrdenacao(result.order);
    },
    [ordenacao.arrow, history.location.search]
  );

  const tableHeader = useMemo(
    () =>
      controller.makeCabecalhoTabela(ordenacao, applyOrder, {
        checked: selectAll,
        onChange: changeSelectAll,
      }),
    [applyOrder, ordenacao, selectAll, changeSelectAll]
  );

  const totalSelecionados = useMemo(
    () =>
      Object.keys(selectedIds).filter((id) => selectedIds[id] === true).length,
    [selectedIds]
  );

  useEffect(() => {
    setDropdownValues(
      controller.makeDefaultDropdownSimpleSearch(controller.filters)
    );
    setLoading(true);

    const notificacao = new URLSearchParams(history.location.search).get(
      'notificacao'
    );
    if (notificacao) {
      pesquisarProcessosComNotificacoes();
      return;
    }
    const autorizacao = new URLSearchParams(history.location.search).get(
      'autorizacao'
    );
    if (autorizacao) {
      pesquisarProcessosComAutorizacoes();
      return;
    }

    const acao = new URLSearchParams(history.location.search).get('acao');
    if (acao) {
      pesquisarProcessosCardMural(acao);
      return;
    }

    controller
      .pesquisarProcessoCarregarPagina()
      .then((data) => {
        if (data.naoCarregar) {
          return;
        }
        setDadosPesquisa(data.processos);
        setSelectedIds(data.idsProcessos);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [
    pesquisarProcessosCardMural,
    history.location.search,
    pesquisarProcessosComNotificacoes,
    pesquisarProcessosComAutorizacoes,
  ]);

  useEffect(() => {
    if (dadosPesquisa?.content?.length > 0) {
      setSelectAll(
        Object.keys(selectedIds).every((key) => selectedIds[key] === true)
      );
    }
    setConteudoTabela(
      controller.makeConteudoTabela(dadosPesquisa?.content, {
        selectedIds,
        changeSelectId,
      })
    );
  }, [dadosPesquisa, changeSelectId, selectedIds]);

  useEffect(() => {
    dispatch(findFasesAction());
    dispatch(findNegociadoresAction());
  }, [dispatch]);

  useEffect(() => {
    dispatch(initializePageAction('Pesquisar Processos'));
  }, [dispatch]);

  useEffect(() => {
    async function loadUser() {
      const response = await getUsuarioCompletoPeloId(idUsuarioLogado);
      setTipoUsuarioLogado(response.data);
    }

    loadUser();
  }, [idUsuarioLogado]);

  return (
    <Container>
      <LoadingUI show={isLoading([...loadingDropdowns, loading])} />
      <SimpleSearchContainer
        ref={simpleSearchFormRef}
        onSubmit={pesquisaComFiltroSimples}
        onReset={resetSimpleSearch}
      >
        <SearchButton type="submit">
          <SearchIcon style={{ marginLeft: 2 }} />
        </SearchButton>
        <NumberInput
          numberType="integer"
          maxValue={999999999}
          name="numeroProcesso"
          label="Número do Processo"
          value={numeroProcesso}
          acceptEmptyValue
          onChange={(e) => setNumeroProcesso(e.target.value)}
        />
        <div style={{ width: '259px' }}>
          <SelectorField
            hasEmptyLabel
            fullWidth
            name="idFase"
            label="Fase"
            items={simpleSeachDropdown.fases}
            value={dropdownValues.idFase}
            onChange={changeDropdown}
          />
        </div>
        <div style={{ width: '302px' }}>
          <SelectorField
            defaultValue={controller.filters.idUsuarioNegociador}
            hasEmptyLabel
            name="idUsuarioNegociador"
            label="Negociador"
            items={simpleSeachDropdown.negociadores}
            value={
              idUsuarioLogadoNaLista
                ? idUsuarioLogado
                : dropdownValues.idUsuarioNegociador
            }
            disabled={idUsuarioLogadoNaLista}
            onChange={changeDropdown}
          />
        </div>
        <div style={{ width: '220px', marginTop: 'auto' }}>
          <CheckboxField
            name="isIgnorarBaixa"
            label="Exibir somente processos ativos"
            value={isIgnorarBaixa}
            checked={isIgnorarBaixa}
            onChange={() => {
              setIsIgnorarBaixa(!isIgnorarBaixa);
            }}
          />
        </div>
      </SimpleSearchContainer>
      <PesquisaComplementarProcesso
        ref={advancedSearchRef}
        pesquisarComFiltroEspecial={pesquisarComFiltroEspecial}
        pesquisarComFiltroAvancado={pesquisarComFiltroAvancado}
      />

      <ComplementarySearchButton type="button" onClick={openAdvancedSearch}>
        Pesquisa Avançada
      </ComplementarySearchButton>

      <Table>
        {totalSelecionados === 0 ? (
          <TableTitle> Resultado da Pesquisa</TableTitle>
        ) : (
          <AcoesPesquisaProcesso
            setLoading={setLoading}
            simpleSearchFormRef={simpleSearchFormRef}
            advancedSearchRef={advancedSearchRef}
            idsProcessos={selectedIds}
            totalSelecionados={totalSelecionados}
          />
        )}

        <TabelaPesquisaProcessos
          columns={tableHeader}
          rows={conteudoTabela}
          page={dadosPesquisa.pageable.page}
          size={dadosPesquisa.totalElements}
          rowsPerPageOptions={[15, 20, 25]}
          rowsPerPage={dadosPesquisa.pageable.size}
          onChangePage={changePageHandler}
          onChangeRowsPerPage={changeRowPerPageHandler}
        />
      </Table>
    </Container>
  );
}

export default withTokenInterceptor(PesquisarProcessosPage);
